module.exports = __webpack_public_path__ + "static/media/bell.b009a550.svg";